import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText, Button, Icon, TextLink, useResponsive } from '@garnish/core';

export const ForgotToScanSuccess = (props: ForgotToScanSuccessProps) => {
  const { onViewPointsHistory, onBack } = props;

  const { match } = useResponsive();

  return (
    <View style={match([styles.containerXS, styles.containerSM])}>
      <View style={styles.content}>
        <Icon name="IconSgRewardKaleFill" width={67} height={67} />

        <BodyText style={styles.title} sizeMatch={['24']}>
          <FormattedMessage {...messages.title} />
        </BodyText>

        <BodyText style={styles.text} sizeMatch={['16']}>
          <FormattedMessage {...messages.subtitle} />
        </BodyText>
      </View>

      <View style={styles.content}>
        <Button palette="kaleLightest" size="large-wide" onPress={onViewPointsHistory}>
          <FormattedMessage {...messages.viewPointsHistory} />
        </Button>

        <TextLink sizeMatch={['16']} style={styles.link} onPress={onBack}>
          <FormattedMessage {...messages.backToHome} />
        </TextLink>
      </View>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  containerXS: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing['4'],
    paddingBottom: theme.spacing['10'],
  },
  containerSM: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing['10'],
    paddingBottom: theme.spacing['20'],
  },
  content: {
    alignItems: 'center',
    gap: theme.spacing['6'],
  },
  title: {
    color: theme.colors.KALE,
    textAlign: 'center',
  },
  text: {
    textAlign: 'center',
  },
  link: {
    color: theme.colors.SPINACH,
    textAlign: 'center',
  },
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  title: {
    defaultMessage: 'Your request was successful!',
    description: 'Forgot To Scan | Success | Title',
  },
  subtitle: {
    defaultMessage: 'Points were added to your account.',
    description: 'Forgot To Scan | Success | Subtitle',
  },
  viewPointsHistory: {
    defaultMessage: 'View your points history',
    description: 'Forgot To Scan | Success | View points history',
  },
  backToHome: {
    defaultMessage: 'Back to home',
    description: 'Forgot To Scan | Success | Back',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type ForgotToScanSuccessProps = {
  onViewPointsHistory: () => void;
  onBack: () => void;
};
